var scope_0 = require('/opt/build/repo/examples/2drive/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9106e5876a748330f633d5e5890d85fc.js').default;
var scope_1 = require('/opt/build/repo/examples/2drive/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/bf7c2952a4e40aac5fd6cb04341970b8.js').default;
var scope_2 = require('/opt/build/repo/examples/2drive/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    